module.exports = __webpack_public_path__ + "static/media/CTLI_5-178w.eb5ce733.png";